//@ts-nocheck

export const getTripAssignedDiscountCodes = (trip = {}) => {
  const discountCodes =
    trip?.discountCodes ?? trip?.discountcodes ?? trip?.discountcode;

  return Array.isArray(discountCodes) ? discountCodes : [];
};

export const hasTripAssignedDiscountCodes = (trip = {}) =>
  getTripAssignedDiscountCodes(trip).length > 0;
